module.exports = {
  slug: `humanrightsquiz`, // page slug, must not contain spaces
  title: `HOW HOT IS THE UK ON HUMAN RIGHTS? TAKE THE QUIZ NOW`, // page title
  meta: { // share copy
    title: `How hot is the UK on human rights? Take the quiz now >>`, // fb share title
    desc: `In the era of fake news, can you spot the truth? 👁️ 🔍`, // fb share description
    image: require(`../assets/humanrights_banner_mobile.jpg`), // fb share image
    whatsapp: `I got [SCORE] out of 6 on this Amnesty quiz... can you spot the UK's hidden hypocrisy and beat my score? 😡🔥 ` // whatsapp share text (don't add a link, we auto add this after)
  },
  header: { // This is the text you see at the top of the page on the first question
    title: `HOW HOT IS THE UK ON HUMAN RIGHTS?<br>TAKE THE QUIZ NOW`, // title text, you can add standard text formatting html tags in here (strong, i etc.) and also line breaks <br>, but nothing else.
    subtitle: `Can you spot the UK's hidden hypocrisy? The truth might surprise you...` // No html, just raw text
  },
  questions: [ // questions array, you can have as many question objects as you want
    {
      backgroundImage: require(`../assets/humanrights_q1.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q1_mobile.jpg`),
      question: `Can an LGBTI+ person receive 'conversion therapy' in the UK?`,
      answers: [
        `No, it was banned in 2002`,
        `It's illegal, but still exists`,
        `Yes, it's legal`
      ],
      userAnswer: null,
      answer: 2,
      answerText: `Unbelievably, conversion therapy is still legal in the UK.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q2.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q2_mobile.jpg`),
      question: `Is a black person more likely than a white person to be tasered by police in England and Wales?`,
      answers: [
        `Yes, 3x as likely`,
        `Yes, 8x as likely`,
        `No`
      ],
      userAnswer: null,
      answer: 1,
      answerText: `Police are nearly 8x more likely to use tasers against black people than white people in England and Wales. Stats are different in Scotland and NI.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q3.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q3_mobile.jpg`),
      question: `Could you be deported to a country that you've never been to, even if you were born and raised in the UK?`,
      answers: [
        `Yes`,
        `No`,
      ],
      userAnswer: null,
      answer: 0,
      answerText: `People born in the UK with the right to British citizenship have been deported to countries they've never even visited.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q4.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q4_mobile.jpg`),
      question: `What has the UK contributed to the Saudi-led attacks that left millions of Yemeni people dead, homeless and starving?`,
      answers: [
        `£1.7billion of aid to Yemen`,
        `£5.3billion of weapons to Saudi Arabia `,
        `A peace deal via trade sanctions`,
      ],
      userAnswer: null,
      answer: 1,
      answerText: `Despite supporting Yemen with aid, the UK has sold £5.3billion in weapons to Saudi Arabia during the conflict.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q5.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q5_mobile.jpg`),
      question: `Could you be imprisoned for peacefully protesting in the UK?`,
      answers: [
        `No, we have the right to protest`,
        `Yes, 6 months for 'disturbing the peace'`,
        `Yes, under terrorism-related law you risk a life sentence`,
      ],
      userAnswer: null,
      answer: 2,
      answerText: `Peaceful protestors have been charged with terrorism-related law, which risks a life sentence.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q6.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q6_mobile.jpg`),
      question: `True or false? The UK government were recently stopped from making it easier to get away with torturing people overseas.`,
      answers: [
        `True`,
        `False`,
      ],
      userAnswer: null,
      answer: 0,
      answerText: `The UK government were stopped from making it nearly impossible to prosecute soldiers for torturing people in conflict more than five years ago.`
    },
  ],
  signAsk: { // this is the petition ask page, comes directly after the questions (unless on /supporter in which case this and the petition page dont show)
    image: require(`../assets/humanrights_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_banner_mobile.jpg`), // switches to this when less than 768px wide
    title: `Before you get your results...`, // the title
    copy: `<p>The freedom to be whoever you were born to be is a fundamental human right.<br>
    But the reality is that trans and non-binary people in the UK still face abuse and discrimination on a daily basis.<br>
At Amnesty, we believe the government must step up the fight for LGBTI+ equality.</p>`, // this can be html, you should wrap each para in <p></p> to get proper styling
    question: `<p>Do you agree?</p>`, // this is the text/question that shows above the buttons, you should wrap each para in <p></p> to get proper styling
    yes_btn: `Yes, absolutely`, // standard string, shows on the button that goes to the petition
    no_btn: `No, sorry` // standard string, shows on the button that skips the petition and goes to the share ask
  },
  sign: { // petition page
    image: require(`../assets/humanrights_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_banner_mobile.jpg`), // switches to this when less than 768px wide
    title: `THAT’S GREAT, THANK YOU!`, // the title
    subTitle: `Trans and non-binary people deserve to be free from abuse and discrimination.`, // this shows under the main title
    subTitle_quote: true, // this decides whether you want it styling as a quote (adds quotation marks and modifies spacing)
    petitionTitle: `ADD YOUR NAME`, // this the large text like "ADD YOUR NAME", that shows above the iframe
    EN_URL: `https://actions.amnesty.org.uk/page/77621/petition/1` // this is the URL to the EN petition you want to embed
  },
  shareAsk: { // / results screen
    image: require(`../assets/humanrights_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_banner_mobile.jpg`), // switches to this when less than 768px wide
    imageAlt: require(`../assets/humanrights_care_homes_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMobAlt: require(`../assets/humanrights_care_homes_banner_mobile.jpg`), // switches to this when less than 768px wide
    question: `<p>Pretty shocking, right? Now will you challenge your friends to beat your score? It only takes 30 seconds to share...</p>`, // this is the text/question that shows above the buttons, you should wrap each para in <p></p> to get proper styling
    yes_btn: `Yes, I'll share`, // standard string, shows on the button that goes to the share slide
    no_btn: `No, sorry` // standard string, shows on the button that skips the share and goes to the donate slide
  },
  donateAsk: {
    image: require(`../assets/humanrights_donate.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_donate_mobile.jpg`), // switches to this when less than 768px wide
    title: `Before you go`, // the title
    copy: `<p>Humanity can't win without you. Can you chip in and help us fight even harder for human rights?</p>`, // this can be html, you should wrap each para in <p></p> to get proper styling
    yes_btn: `Yes, I'll chip in`, // standard string, shows on the button that goes to the donate link and scrolls to the thanks slide
    donate_link: `https://www.amnesty.org.uk/giving/donate/give-now-quote-generator-one-madi093?amount=5&utm_campaign=UKhumanrightsquiz_MAIN530T&utm_source=UKhumanrightsquiz&utm_medium=referral&utm_content=DonateButtonOn`, // this is the link the donate (yes) button goes to
    no_btn: `No, sorry` // standard string, shows on the button that skips the donate link and goes to the thanks slide
  },
  thanks: {
    image: require(`../assets/humanrights_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_banner_mobile.jpg`), // switches to this when less than 768px wide
    title: `THANKS FOR TAKING THE QUIZ`, // the title
    copy: `<p>It highlights just some of the injustice that's happening right now in the UK.</p><p>If you want to help to build a world that's fairer for everyone, take a look at some of our most urgent campaigns today.</p>`, // this can be html, you should wrap each para in <p></p> to get proper styling
    btn_text: `SHOW ME URGENT CAMPAIGNS`, // this is the generic button at the end
    btn_link: `https://www.amnesty.org.uk/issues/human-rights-uk` // this is the link the button at the end goes to
  }
}